import { render, staticRenderFns } from "./Troubleshooting.vue?vue&type=template&id=72e8851a"
import script from "./Troubleshooting.vue?vue&type=script&lang=js"
export * from "./Troubleshooting.vue?vue&type=script&lang=js"
import style0 from "./Troubleshooting.vue?vue&type=style&index=0&id=72e8851a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports